import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GenericPieTableTemplate from '../Shared/GenericPieTableTemplate.jsx'
import ChartUtility from '../../Helpers/ChartUtility'

class PortfolioTopBaseComponent extends Component {
  constructor(props) {
    super(props)

    this.init()
  }

  createChart(options) {
    options = options || {}

    this.chartUtility = new ChartUtility({
      data: this.props.fund,
      details: this.props.meta.details,
      pie: {
        nameField: options.nameField || 'name',
        valueField: options.valueField || 'fundPercent',
        value2Field: options.value2Field || 'indexPercent',
      },
    })
  }

  init() {
    const { topLevelId, details } = this.props.meta
    const { index } = this.props

    switch (topLevelId) {
      case 'top-sectors':
        this.createChart({
          nameField: 'sectorName',
          valueField: 'fundWeightPercent',
          value2Field: 'indexPercent',
        })
        break
      case 'asset-allocation':
        this.chartUtility = new ChartUtility({
          data: this.props.fund,
          details: details,
          pie: {
            nameField: 'allocation',
            valueField: 'allocationPercent',
            value2Field: '',
          },
        })
        break
      case `asset-mix-${index}`:
        this.chartUtility = new ChartUtility({
          data: this.props.fund,
          details: details,
          pie: {
            nameField: 'allocationType',
            valueField: 'allocationPct',
            value2Field: '',
          },
        })
        break
      default:
        this.createChart()
        break
    }
  }

  componentDidMount() {
    const { topLevelId } = this.props.meta

    this.chartUtility.renderPieChart(topLevelId)
  }

  render() {
    const { meta, showDivider } = this.props
    const holdings = this.chartUtility.normalizeTableData()
    const pieChartDescription = this.chartUtility.getPieChartDescription(
      meta.pieChartPrefix
    )

    return (
      <div id={meta.topLevelId}>
        <GenericPieTableTemplate
          showDivider={showDivider}
          sectionLabel={meta.sectionLabel}
          sectionAsOfDate={meta.asOfDate}
          pieChartTableHeader={meta.pieChartTableHeader}
          pieChartDescription={pieChartDescription}
          pieChartId={meta.topLevelId + '-pie-chart'}
          tableId={meta.topLevelId + '-table'}
          tableData={{
            firstHeading: meta.firstHeading,
            secondHeading: meta.secondHeading,
            thirdHeading: meta.indexHeading || null,
            holdings: holdings,
          }}
        />
      </div>
    )
  }
}
PortfolioTopBaseComponent.propTypes = {
  fund: PropTypes.object,
  meta: PropTypes.object,
}

export default PortfolioTopBaseComponent
